/**
 * Map a thread `diff_status` (added / modified / removed vs master) to the CSS
 * classes used to badge an entity or artefact row while viewing a thread branch.
 * `null`/absent (unchanged, or not viewing a thread) yields no class.
 *
 * Shared by the <c-stekz-tree> product/process tree and the documents
 * (artefacts) table so both render thread diffs identically: green = added,
 * amber = modified, strikethrough + dimmed = removed (a ghost).
 */
export function diffStatusClasses(entity: {
    diff_status?: string | null;
}): Record<string, boolean> {
    return {
        "diff-added": entity.diff_status === "added",
        "diff-modified": entity.diff_status === "modified",
        "diff-removed": entity.diff_status === "removed",
    };
}
